import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import { getCreatureOffsets } from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import AnimatedFriend from './AnimatedFriend';

export default class Friend extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, friendID) {
    super(scene);

    this.friendID = friendID;

    this.msgContainer = null;
    this.lblMsg = null;

    this.markDisplayContainer = null;
    this.marks = null;

    this.font = null;

    this.startPos = null;
    this.curPos = null;
    this.destPos = null;
    this.vX = null;
    this.vY = null;
    this.direction = 1;
    this.speed = 42;
    this.ease = 0.14;

    this.msgPositions = null;

    this.isHovering = true;

    this.turnContainer = this.scene.add.container();

    const offsets = getCreatureOffsets(`Friend${this.friendID}`);
    this.characterContainer = this.scene.add.container();
    this.character = new AnimatedFriend(this.scene, 'Friend', this.friendID, offsets);
    this.character.startSwimming();
    this.characterContainer.add(this.character);
    this.add(this.characterContainer);

    const bounds = this.getBounds();

    this.characterContainer.list.forEach((child) => {
      // eslint-disable-next-line no-param-reassign
      child.x -= bounds.width / 2;
      // eslint-disable-next-line no-param-reassign
      child.y -= bounds.height / 2;
    });

    ABCyaPhaser.Container.setContainerInteractive(this);
    this.scene.input.setDraggable(this, true);

    this.msgContainer = this.scene.add.container();
    this.msgBubble = ABCyaPhaser.Images.addImage(this.character.getBounds().width, 0, UIAssetKeys._ClamSpeechBubble, this.msgContainer).setOrigin(0);
    this.msgBubble.y = -this.msgBubble.height;
    this.msgBubble.scaleX = -1;

    this.msgPositions = [[{ x: -10,y: -10 },{ x: 10,y: -10 }],[{ x: 0,y: 0 },{ x: 0,y: -10 }],[{ x: 48,y: -30 },{ x: -48,y: -30 }]];
    const bi = this.direction > 0 ? 0 : 1;
    this.msgContainer.x = this.msgPositions[this.friendID - 1][bi].x;
    this.msgContainer.y = this.msgPositions[this.friendID - 1][bi].y;

    this.font = FontKeys._bpreplaybold;
    this.lblMsg = ABCyaPhaser.Text.addText(0,0, 22, 0x006699, this.font, ABCyaPhaser.Localization.instance.getLocalizedString('tap_fish'), this.msgContainer, true).setOrigin(0.5,0);
    this.lblMsg.x = this.msgBubble.x - 104 * this.direction;
    this.lblMsg.y = -(this.msgBubble.height / 2) - this.lblMsg.height / 2 - 25;

    this.msgContainer.alpha = 0;

    this.marks = [];
    this.markDisplayContainer = this.scene.add.container();

    const poss = [{ x: -10,y: 0 },{ x: 50,y: 0 },{ x: -10,y: 60 },{ x: 50,y: 60 }];
    for (let i = 0; i < 4; i++) {
      const m = ABCyaPhaser.Images.addImage(poss[i].x, poss[i].y, UIAssetKeys._countmark_1, this.markDisplayContainer);
      m.alpha = 0;
      this.marks.push(m);
      this.markDisplayContainer.add(m);
    }
    this.markDisplayContainer.y = -this.msgBubble.height + 40;
    this.markDisplayContainer.x = 20;

    this.msgContainer.add(this.markDisplayContainer);
    this.add([this.turnContainer, this.msgContainer]);
  }

  showCount (num) {
    const len = this.marks.length;
    const full = Math.floor(num / 5);
    const singles = num - full * 5;
    for (let i = 0; i < len; i++) {
      this.marks[i].alpha = 0;
    }
    for (let i = 0; i < len; i++) {
      if ((i + 1) <= full) {
        this.marks[i].setFrame(UIAssetKeys._countmark_5);
        this.marks[i].alpha = 1;
      }
      else if (singles > 0) {
        this.marks[i].setFrame(`countmark_${singles}`);
        this.marks[i].alpha = 1;
        break;
      }
      else {
        break;
      }

    }
    if (num === 0 || !num) {
      this.lblMsg.text = ABCyaPhaser.Localization.instance.getLocalizedString('tap_fish');
      this.lblMsg.y = -(this.msgBubble.height / 2) - this.lblMsg.height / 2 - 25;
    }
    else {
      this.lblMsg.text = ' ';
    }
    this.scene.tweens.killTweensOf(this.msgContainer);
    ABCyaPhaser.Tweens.addTween(this.msgContainer, 500, { alpha: 1, completeDelay: 1500 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.msgContainer, 250, { alpha: 0 }, Phaser.Math.Easing.Linear);
    });
  }

  turnDir (direction) {
    if (direction !== this.direction) {
      this.scene.tweens.killTweensOf(this.characterContainer);
      this.characterContainer.scaleX = this.direction;
      this.direction = direction;
      ABCyaPhaser.Tweens.addTween(this.characterContainer, 200, { scaleX: this.direction }, Phaser.Math.Easing.Linear);
      const bi = this.direction > 0 ? 0 : 1;
      this.msgContainer.x = this.msgPositions[this.friendID - 1][bi].x;
      this.msgContainer.y = this.msgPositions[this.friendID - 1][bi].y;
      this.msgBubble.scaleX = this.direction * -1;
      this.msgBubble.x = this.character.getBounds().width * this.direction;
      this.msgBubble.y = -this.msgBubble.height;
      this.lblMsg.x = this.msgBubble.x - 104 * this.direction;
      if (this.direction > 0) {
        this.markDisplayContainer.x = 10;
      }
      else {
        this.markDisplayContainer.x = this.msgBubble.x + 60;
      }
    }
  }

  initializeSwimTo (destX, destY) {
    this.swimState = SWIM_TO_POINT;
    this.startPos = { x: this.x, y: this.y };
    this.curPos = { x: this.x, y: this.y };
    this.destPos = { x: destX, y: destY };
    this.speed = 13;
    let direction = Phaser.Math.Angle.BetweenPointsY(this.curPos, this.destPos);
    if (direction === 0) {
      direction = this.direction;
    }
    direction = direction / Math.abs(direction);
    if (direction !== this.direction) {
      this.turnDir(direction);
    }
    this.ease = 0.2;
    this.directionAngle = Math.atan2(destY - this.curPos.y, destX - this.curPos.x);
    this.distanceToTarget = Phaser.Math.Distance.BetweenPoints(this.curPos, this.destPos);
    this.distanceTraveled = 0;
  }

  initializeHover () {
    this.speed = 1.8;
    this.ease = 0.02;
    this.hoverRange = 4;
    this.maxLeft = this.x - this.hoverRange;
    this.maxTop = this.y - this.hoverRange * 2;
    this.maxRight = this.x + this.hoverRange;
    this.maxBottom = this.y + this.hoverRange * 2;

    this.startPos = { x: this.x, y: this.y };
    this.curPos = { x: this.x, y: this.y };
    this.destPos = { x: Phaser.Math.Between(this.maxLeft, this.maxRight), y: Phaser.Math.Between(this.maxTop, this.maxBottom) };
    this.swimState = SWIM_HOVER;
  }

  resetCount () {
    const len = this.marks.length;
    for (let i = 0; i < len; i++) {
      this.marks[i].alpha = 0;
    }
  }

  hoverSwim () {
    if (this.isHovering) {
      const dX = this.destPos.x - this.curPos.x;
      const dY = this.destPos.y - this.curPos.y;
      const distance = Phaser.Math.Distance.BetweenPoints(this.curPos, this.destPos);
      if (distance > 1) {
        this.curPos.x += dX * this.ease;
        this.curPos.y += dY * this.ease;
      }
      else {
        this.curPos.x = this.destPos.x;
        this.curPos.y = this.destPos.y;
        this.pickNewHoverSpot();
      }
    }
  }

  swimStraight () {
    const workingX = this.curPos.x + Math.cos(this.directionAngle) * this.speed;
    const workingY = this.curPos.y + Math.sin(this.directionAngle) * this.speed;
    this.distanceTraveled = Phaser.Math.Distance.BetweenPoints(this.startPos, { x: workingX,y: workingY });
    if (this.distanceTraveled >= this.distanceToTarget) {
      if (this.swimState === SWIM_HOVER) {
        this.pickNewHoverSpot();
      }
      else {
        this.initializeHover();
        this.emit('FISH_ARRIVED_TO_DEST');
      }
    }
    else {
      this.curPos.x = workingX;
      this.curPos.y = workingY;
    }
  }

  pickNewHoverSpot () {
    this.startPos = { x: this.x, y: this.y };
    this.curPos = { x: this.x, y: this.y };
    const destX = Phaser.Math.Between(this.maxLeft, this.maxRight);
    const destY = Phaser.Math.Between(this.maxTop, this.maxBottom);
    this.destPos = { x: destX, y: destY };

    this.ease = 0.01;
  }

  pickup () {
    this.swimState = null;
  }

  tick (delta) {
    switch (this.swimState) {
      case SWIM_HOVER:
        this.hoverSwim();
        break;
      case SWIM_TO_POINT:
        this.swimStraight();
        break;
    }
    if (this.swimState) {
      this.x = this.curPos.x;
      this.y = this.curPos.y;
    }
    this.character.tick(delta);
  }
}

const SWIM_TO_POINT = 1;
const SWIM_HOVER = 2;
const SWIM_STOP = 3;
const SWIM_ROAM = 4;